namespace GeniuzPOS.Purchase {
    export enum UnitChangeEnumFg {
        StkUnit = 0,
        PurUnit = 1
    }
    Serenity.Decorators.registerEnumType(UnitChangeEnumFg, 'GeniuzPOS.Purchase.UnitChangeEnumFg');
}
